import Widget from '../Widget/Widget';
import { computed } from 'vue';

export default class ButtonHeader extends Widget {
	private fitText = computed((): string => {
		if (this.isFullProfile.value) {
			return `${this.displayScore.value}`;
		}
		if (this.emptyText !== null) {
			return this.emptyText;
		}

		return '';
	});

	mounted(): void {
		this.waitForSession();
		this.animateIcon();
	}
}
